import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import "../assets/css/main-style.css";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import {
  handleForgetPassword,
  handleUserLogin,
} from "../auth/Auth";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/slice/user";
import { toast } from "react-toastify";
import Header from "../components/Header";
import Modal from "react-modal";
import { initializeUserCart } from "../../store/slice/cart";

const SignIn = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [isPending, setIsPending] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);

  const backgroundStyle = {
    backgroundImage: 'url("./media/frontend/img/banner/banner-2.jpg")',
  };

  useEffect(() => {
    if (userInfo) navigate("/");
  }, [userInfo, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  // Form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsPending(true);
    try {
      const res = await handleUserLogin(credentials);
      dispatch(loginUser(res));
      dispatch(initializeUserCart({ userId: res.data.id }));
      toast.success(res.message);
    } catch (error) {
      toast.error(error.message || "An unexpected error occurred.");
    } finally {
      setIsPending(false);
    }
  };

  // Forget Password Modal
  const [forgetPassword, setForgetPassword] = useState({
    email: "",
  });
  const [isOpen, setIsOpen] = useState(false);
  const onRequestClose = () => {
    setIsOpen(false);
  };
  const forgetPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsPending(true);
      const response = await handleForgetPassword(forgetPassword);
      if (response.message || response.msg) {
        toast.success(response.message || response.msg);
        onRequestClose();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <>
      <Header />

      <div className="position-relative h-[97vh] md:px-2 px-4">
        <div className="lg:w-2/3 w-full mx-auto h-full flex items-center my-auto py-5">
          <div className="authForm w-full">
            <div className="grid grid-cols-12">
              <div className="md:col-span-6 col-span-12 md:order-1 order-2">
                <div className="form-container md:p-12 p-6 text-center w-full max-w-md mx-auto">
                  <form action="#" onSubmit={handleSubmit}>
                    <h1 className="genHead mb-4">Sign in</h1>
                    <div className="w-[40px] h-[2px] bg-primary mx-auto mb-6"></div>
                    
                    <input
                      value={credentials.email}
                      name="email"
                      onChange={handleChange}
                      required
                      className="mb-4"
                      type="email"
                      placeholder="john@example.com"
                    />
                    <div className="relative mb-4">
                      <input
                        value={credentials.password}
                        name="password"
                        onChange={handleChange}
                        required
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        className="w-full px-4 py-2 pr-12 border border-gray-300 rounded focus:outline-none"
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-4">
                        <button
                          type="button"
                          onClick={() => setShowPassword((prev) => !prev)}
                          className="text-gray-500 focus:outline-none"
                          tabIndex={-1}
                        >
                          <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                          />
                        </button>
                      </div>
                    </div>

                    <div className="forgotTxt mb-4">
                      <button
                        type="button"
                        onClick={() => setIsOpen(true)}
                        className="hover:underline mb-2 text-primary"
                      >
                        Forgot your password?
                      </button>
                      <div className="text-sm text-gray-700 mb-3">
                        New customer?{" "}
                        <Link className="font-semibold text-primary hover:underline transition-colors" to="/#chef">
                          Sign up
                        </Link>
                      </div>
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="text-sm text-gray-700"
                      >
                        Wanna become a Shef?{" "}
                        <Link
                          to="/become-a-chef"
                          className="font-semibold text-primary hover:underline transition-colors"
                        >
                          Become a chef
                        </Link>
                      </motion.div>
                    </div>

                    <button
                      disabled={isPending}
                      className="fillBtn w-full disabled:cursor-not-allowed disabled:opacity-60"
                      type="submit"
                    >
                      {isPending ? "Signing In..." : "Sign In"}
                    </button>
                  </form>
                </div>
              </div>
              <div className="md:col-span-6 col-span-12 md:order-2 order-1">
                <div
                  className="authImgSide lg:py-0 py-24"
                  style={backgroundStyle}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Forget Password Modal */}
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Reviews"
        style={{
          content: {
            height: "max-content",
            top: "20%",
            maxWidth: "500px",
            marginLeft: "auto",
            marginRight: "auto",
          },
        }}
      >
        <div className="">
          <div className="flex items-center justify-between border-b pb-3 gap-3">
            <h2 className="text-lg font-semibold leading-tight mb-0">
              Forgot Your Password?
            </h2>
            <button onClick={onRequestClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="rgba(0,0,0,1)"
              >
                <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
              </svg>
            </button>
          </div>

          <form onSubmit={forgetPasswordSubmit} className="mt-5" action="">
            <p className="text-xs sm:text-base mb-3">
              Enter your email address to receive a reset password link.
            </p>
            <input
              value={forgetPassword.email}
              onChange={(e) =>
                setForgetPassword((prev) => {
                  return { ...prev, email: e.target.value };
                })
              }
              className="my-1 mb-4"
              type="email"
              required
              name="email"
              placeholder="Enter your email address"
            />
            <button
              disabled={isPending}
              type="submit"
              className="my-2 text-base w-max bg-primary text-white uppercase px-6 py-2 font-semibold rounded-lg disabled:cursor-not-allowed disabled:opacity-60 mt-auto"
            >
              {isPending ? "Processing..." : "Send Reset Password Link"}
            </button>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default SignIn;